import React, {useEffect, useState} from "react";
import profilePicture from '../../../resources/avatarShuffle.webp';
import {useLazyQuery} from "@apollo/client";
import {
    HOMEPAGE_LEADERBOARD,
    HOMEPAGE_LEADERBOARD_LUXDROP,
    HOMEPAGE_LEADERBOARD_SHUFFLE,
    HOMEPAGE_LEADERBOARDPRIZES, HOMEPAGE_LEADERBOARDPRIZES_LUXDROP
} from "../../../queries/queries";
import {number_format, anonymizeUsername} from "../../../helpers";
import Countdown, {zeroPad} from "react-countdown";
import moment from "moment";
import {Helmet} from "react-helmet";
import {websiteName} from "../../../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWarning} from "@fortawesome/free-solid-svg-icons";


const LuxdropLeaderboard = ({showMinimalDetails}) => {

    const [leaderboard, setLeaderboard] = useState([]);
    const [leaderboardPrizes, setLeaderboardPrizes] = useState([]);

    const [leaderboardRemaining, setLeaderboardRemaining] = useState([]);
    const [leaderboardFirst, setLeaderboardFirst] = useState();
    const [leaderboardSecond, setLeaderboardSecond] = useState();
    const [leaderboardThird, setLeaderboardThird] = useState();
    const [nextResetTimestamp, setNextResetTimestamp] = useState(null);
    const [lastSyncTime, setLastSyncTime] = useState(null);
    const [totalReward, setTotalReward] = useState(null);

    const [getLeaderboard, {loading, refetch}] = useLazyQuery(HOMEPAGE_LEADERBOARD_LUXDROP, {
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setLeaderboard(e.getLeaderboardLuxdrop);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboardPrizes, {loadingPrize, refetchPrize}] = useLazyQuery(HOMEPAGE_LEADERBOARDPRIZES_LUXDROP, {
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setLeaderboardPrizes(e.getLeaderboardPrizesLuxdrop);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const getRewardAtPosition = position => {
        return leaderboardPrizes[position - 1] ? leaderboardPrizes[position - 1].Reward : '';
    };

    const renderer = ({formatted: {days, hours, minutes, seconds}, completed}) => {
        return <div className="cdWrapper">
            <div>
                <div className="cdValue">{zeroPad(days)}</div>
                <div className="cdText">Days</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(hours)}</div>
                <div className="cdText">Hours</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(minutes)}</div>
                <div className="cdText">Mins</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(seconds)}</div>
                <div className="cdText">Secs</div>
            </div>
        </div>;
    };

    useEffect(() => {
        if (leaderboard && leaderboard.length > 0) {
            setLeaderboardFirst(leaderboard.slice(0, 1)[0]);
            setLeaderboardSecond(leaderboard.slice(1, 2)[0]);
            setLeaderboardThird(leaderboard.slice(2, 3)[0]);
            setLeaderboardRemaining(leaderboard.slice(3, 50));
        }
    }, [leaderboard]);

    useEffect(() => {
        getLeaderboard();
        getLeaderboardPrizes();
        const timestamp = moment().utc().endOf('month');

        setNextResetTimestamp(timestamp.toDate());
    },[]);

    useEffect(() => {
        setTotalReward(leaderboardPrizes.reduce((sum, prize) => sum + prize.Reward, 0))
    }, [leaderboardPrizes]);

    return (
        <div className={`fadeIn lb-roobet`}>

            <Helmet>
                <title>{`${websiteName} | Luxdrop Leaderboard`}</title>
            </Helmet>

            <div className="lbTotalAmount" style={{textAlign: "center", marginTop: 30}}>
                <span className="neonHeaderText"><h1 style={{fontSize: '80px'}}><span
                    className="neonSubTextStyled">$</span>3,000</h1></span>
            </div>

            {/*{!showMinimalDetails && <>*/}
            {/*    <div className="lb-countdown" style={{margin: '25px 0'}}>*/}
            {/*        <div className="neonSubText">At the end of every month <span className={"neonSubTextStyled"}>10 random wager's</span> will*/}
            {/*            receive <span className="neonSubTextStyled">$150</span> each!*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</>}*/}

            {!showMinimalDetails && <>
                <div className="lb-countdown">
                    <div className="countdownHeader">LEADERBOARD ENDS IN</div>
                    {nextResetTimestamp && <Countdown
                        zeroPadTime={1}
                        date={nextResetTimestamp}
                        renderer={renderer}
                    />}

                </div>
            </>}

            <div className="lb-podium">
                <div className="entry">
                    {leaderboardSecond && <>
                        <div className="profileWrapper">
                            {}
                            <div className="profilePictureWrapper">
                                <img src={leaderboardSecond.PlayerImage.substring(0,1) === "/" ? `https://luxdrop.com${leaderboardSecond.PlayerImage}` : leaderboardSecond.PlayerImage} className={`profilePicture`}
                                     alt=""/>
                            </div>
                            <div className={"positionWrapper"}>2</div>
                            <p>{anonymizeUsername(leaderboardSecond.PlayerName)}</p>

                        </div>
                        <div className="wageredWrapper">
                            <p className="wageredText">Wagered</p>
                            <p className="wageredValue"><span
                                className="greenDollar">$</span> {number_format(leaderboardSecond.WageredAmount)}</p>
                        </div>
                        <div className="prizeWrapper">
                            <div className="prize">
                                <span className="greenDollar">$</span> {number_format(getRewardAtPosition(2))}
                            </div>
                        </div>
                    </>}
                </div>

                <div className="entry">
                    {leaderboardFirst && <>
                        <div className="profileWrapper">
                            <div className="profilePictureWrapper">
                                <img src={leaderboardFirst.PlayerImage.substring(0,1) === "/" ? `https://luxdrop.com${leaderboardFirst.PlayerImage}` : leaderboardFirst.PlayerImage} className={`profilePicture`}
                                     alt=""/>
                            </div>
                            <div className={"positionWrapper"}>1</div>
                            <p>{anonymizeUsername(leaderboardFirst.PlayerName)}</p>

                        </div>
                        <div className="wageredWrapper">
                            <p className="wageredText">Wagered</p>
                            <p className="wageredValue"><span
                                className="greenDollar">$</span> {number_format(leaderboardFirst.WageredAmount)}</p>
                        </div>
                        <div className="prizeWrapper">
                            <div className="prize">
                                <span className="greenDollar">$</span> {number_format(getRewardAtPosition(1))}
                            </div>
                        </div>
                    </>}
                </div>

                <div className="entry">
                    {leaderboardThird && <>
                        <div className="profileWrapper">
                            <div className="profilePictureWrapper">
                                <img src={leaderboardThird.PlayerImage.substring(0,1) === "/" ? `https://luxdrop.com${leaderboardThird.PlayerImage}` : leaderboardThird.PlayerImage} className={`profilePicture`}
                                     alt=""/>
                            </div>
                            <div className={"positionWrapper"}>3</div>
                            <p>{anonymizeUsername(leaderboardThird.PlayerName)}</p>

                        </div>
                        <div className="wageredWrapper">
                            <p className="wageredText">Wagered</p>
                            <p className="wageredValue"><span
                                className="greenDollar">$</span> {number_format(leaderboardThird.WageredAmount)}</p>
                        </div>
                        <div className="prizeWrapper">
                            <div className="prize">
                                <span className="greenDollar">$</span> {number_format(getRewardAtPosition(3))}
                            </div>
                        </div>
                    </>}
                </div>
            </div>

            {!showMinimalDetails && <>
                {lastSyncTime && <div className="lb-countdown">
                    <div className="cdWrapper">
                        <div className="cdText">
                            Last updated {lastSyncTime}
                        </div>
                    </div>
                </div>}
            </>}

            {!showMinimalDetails && <div className="lb-leaderboardRest">

                <div className="tableHeader">
                    <div className="name">User</div>
                    <div className="wagered">Wagered</div>
                    <div className="prize">Prize</div>
                </div>
                <div className="tableContent">
                    {leaderboardRemaining.map((entry, idx) =>
                        <div className="tableRow" key={idx}>
                            <div className="name">

                                <div className="playerPos">
                                    #{idx + 4}
                                </div>
                                <div className="playerImage">
                                    {/*<img src={entry.PlayerImage??profilePicture} className={`profilePicture`} alt=""/>*/}
                                </div>
                                <div className="playerName">
                                    {anonymizeUsername(entry.PlayerName)}
                                </div>
                            </div>
                            <div className="wagered">
                                <span className="greenDollar">$</span> {number_format(entry.WageredAmount)}
                            </div>
                            <div className="prize"><span
                                className="greenDollar">$</span> {number_format(getRewardAtPosition(idx + 4))}
                            </div>
                        </div>)}
                </div>

            </div>}

        </div>
    )
}

export default LuxdropLeaderboard;